import { createSlice } from '@reduxjs/toolkit';
import { Asset } from '@/types/models/assets.types';
import { FiltersValues, FilterData } from '@/components/uiKit/FiltersGroup/types';

interface notificationPreferencesState {
  allFiltersValues?: FiltersValues;
  initialFiltersValues?: FiltersValues;
  currentFiltersValues?: FiltersValues;
  currentFiltersData?: FilterData[];
  selectedAssets?: Asset[];
}

const initialState: notificationPreferencesState = {};

const notificationPreferencesSlice = createSlice({
  initialState,
  name: 'notificationPreferences',
  reducers: {
    setCurrentFiltersData(state, action) {
      state.currentFiltersData = action.payload;
    },
    setCurrentFiltersValues(state, action) {
      state.currentFiltersValues = action.payload;
    },
    setAllFiltersValues(state, action) {
      state.allFiltersValues = action.payload;
    },
    setInitialFiltersValues(state, action) {
      state.initialFiltersValues = action.payload;
    },
  },
});

export const notificationPreferencesSliceReducer = notificationPreferencesSlice.reducer;

export const { setCurrentFiltersData, setCurrentFiltersValues, setAllFiltersValues, setInitialFiltersValues } =
  notificationPreferencesSlice.actions;
